<template>
	<div class="wrapper pb-5" style="margin-top: 6rem;">
		<b-container>
			<div class="title">
				<a>志愿者招募</a>
				<div class="under-line"></div>
			</div>
			<div class="content">
				<div style="color: #7f7f7f" v-html="content">
					<!-- <p>
						未来论坛一直以来都在关注如何让更多热爱科学，乐于创新的有志青年加入进来。
						于是我们组建了属于自己的志愿者团队-FUTURE
						IN。愿以此启蒙科学精神、唤起科学热情、激励科学创新，提供给更多的青年参与科学公益的机会。加入FUTURE
						IN，我们可以一同感受并学习科学家的那份毅力，企业家的那份创新力，投资家的那份敏锐力。
					</p>
					<p style="color: rgb(49, 133, 155);">
						请如实填写以下表格，并上传个人简历。
					</p> -->
				</div>
				<b-form-group
					v-for="(item, index) in formfield"
					:key="index"
					id="fieldset-1"
					:label="item.name"
					label-for="input-1"
					:invalid-feedback="invalidFeedback"
					:state="state"
				>
					<b-form-input v-if="item.types == '1'"
						id="input-1"
						v-model="form[item.name]"
						:state="state"
						trim
					></b-form-input>
                    <b-form-textarea v-if="item.types == '2'"
                        id="textarea-large"
                        size="lg"
                        v-model="form[item.name]"
						:state="state"
						trim
                    ></b-form-textarea>
				</b-form-group>
                <div v-show="fileName">{{fileName}}</div>
				<div class="btns">
                    <a href="javascript:;" class="a-upload mr-5">
                        <input type="file" @change="fileChange($event)" name="" id="">上传简历
                    </a>
					<b-button type="submit" @click="submit">提交表格</b-button>
				</div>
			</div>
		</b-container>
	</div>
</template>
<script>
import http from '@/api/http.config'
export default {
	computed: {
		invalidFeedback() {
			if (this.name.length > 0) {
				return 'Enter at least 4 characters.'
			}
			return ''
		},
	},
	data() {
		return {
            content: '',
            fileName: '',
			name: '',
			state: null,
			formfield: [
				// {
				// 	text: '姓名*',
                //     field: 'name',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '年龄*',
                //     field: 'age',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '电话*',
                //     field: 'phone',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '邮箱*',
                //     field: 'email',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '机构／院校（例如：**大学）*',
                //     field: 'institution',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '学历（例如：大一／大二／研一...）*',
                //     field: 'education',
                //     type: 'input'
                    
				// },
				// {
				// 	text:
				// 		'专业／学科（例如：生命科学、物理、天体物理、数学、英语......)*',
                //     field: 'profession',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '英语水平（例如：专八／雅思／托福...）*',
                //     field: 'english',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '选择方向：内容传播组／嘉宾组／会务组*',
                //     field: 'direction',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '推荐人（若有请填写）*',
                //     field: 'referrer',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '通过何种渠道或平台了解本志愿者项目*',
                //     field: 'how',
                //     type: 'input'
                    
				// },
				// {
				// 	text: '留言*',
                //     field: 'msg',
                //     type: 'textArea'
				// },
			],
			form: {
				// name: '',
				// age: '',
				// phone: '',
				// email: '',
				// institution: '',
				// education: '',
				// profession: '',
				// english: '',
				// direction: '',
				// referrer: '',
				// how: '',
				// msg: '',
			},
		}
	},
	created(){
        this.getData(localStorage.getItem('BIGWEEKYEAR') || '3')
	},
	methods: {
        
		getData(year){
			this.$api.getVolunteer({
				projectId: year
			})
			.then(res=>{
                this.content = res.data.content
                let arr = JSON.parse(res.data.menus)
                this.formfield = arr;
                let keyArr = arr.map(item=>{
                    return item.name
                });
				keyArr.forEach(item => {
					this.form[item] = ''
				});
			})
        },
		upload() {
            
		},
		submit() {
            let arr = Object.values(this.form)
            let flag = arr.every(item=>{
                return item !== ''
            }) 
            if(flag){
                 this.$api.saveVolunteer({
                     fileId: this.fileId, 
                     table: JSON.stringify(this.form),
                     projectId: localStorage.getItem('BIGWEEKYEAR') || '3'
                     }).then(res=>{
                        alert('提交成功')

                })
            }else{
                alert('请填写完整信息')
            }
           
        },
        fileChange(e){
            let formdata = new FormData();
            let file = e.target.files[0];
            let str = file.name;
            this.fileName = str;
            let arr = str.split('.')
            if(arr[arr.length-1] == 'doc' || arr[arr.length-1] == 'docx'){
                
            }
            formdata.append('fileUploads', file)
            formdata.append('moduleName', 'volunteer')
            this.$api.upLoad(formdata).then(res=>{
                this.fileId = res.data[0].id
            })
            
            
        }
	},
}
</script>
<style lang="scss" scoped>
.title {
	height: 6rem;
	line-height: 6rem;
	margin: 2rem 0px;
	border-bottom: 0.1rem solid #ebebeb;
	overflow: hidden;

	.under-line {
		display: block;
		position: relative;
		top: -0.3rem;
		height: 0.3rem;
		width: 6rem;
		background: #cfaf75;
	}
	a {
		display: block;
		font-size: 1.2rem;
		color: #666666;
		font-weight: bold;
	}
}
.content {
	width: 40rem;
    .a-upload{
        height: 2.3rem;
        width: 10rem;
        line-height: 2.3rem;
        position: relative;
        text-align: center;
        color: #fff;
        background: #cfaf75;
        border-radius: 0.4rem;
        display: inline-block;
        input {
            width: 100%;
            position: absolute;
            font-size: 100px;
            right: 0;
            top: 0;
            opacity: 0;
            filter: alpha(opacity=0);
            cursor: pointer;
        }
    }
}

.btn-secondary {
	width: 10rem;
	color: #fff;
	background-color: #cfaf76;
	border-color: #cfaf76;
}
@media (max-width: 768px) {
	.content {
		width: 100%;
	}
}
</style>
